<div class="translation-entry" [class.ignore-on-hover]="showIgnoreButtonOnHover()">
  <div class="translation-entry__default">
    <div class="translation-entry__default-header">
      <eiq-badge [text]="row().displayKey" [color]="'light'" [shape]="'square'"></eiq-badge>

      @if (row().translatedEntry.outdatedInd) {
        <eiq-badge [icon]="faTriangleExclamation" [text]="'Source changed'" [color]="'alert'"></eiq-badge>
      }

      @if (row().isOptionTranslation && !defaultHasValue$()) {
        <eiq-badge [icon]="faTriangleExclamation" [text]="'Empty Value'" [color]="'alert'"></eiq-badge>
      }

      @if (showIgnoreButton()) {
        <eiq-button
          class="translation-entry__ignore-btn"
          [title]="row().translatedEntry.ignoredInd ? 'Add translation' : 'Ignore translation'"
          [icon]="row().translatedEntry.ignoredInd ? faSquarePlus : faSquareMinus"
          [color]="'primary'"
          [style]="'icon'"
          [testId]="'translation-entry-' + row().key + '-ignore'"
          (clicked)="ignoreEntry.emit(!row().translatedEntry.ignoredInd)"
        ></eiq-button>
      }
    </div>
    <div class="translation-entry__default-value">
      <span class="fs__sm" [innerHtml]="row().defaultEntry.value"></span>
      @if (defaultHasValue$()) {
        <eiq-button
          class="translation-entry__copy-btn"
          [icon]="isCopied$() ? faCheck : faCopy"
          [style]="'icon'"
          [testId]="'translation-entry-' + row().key + '-copy-default'"
          (clicked)="onCopy()"
        ></eiq-button>
      }
    </div>
  </div>

  <div class="translation-entry__active" (focusin)="inputFocused.emit()">
    @if (canEdit$()) {
      @if (!isEditing$()) {
        <div
          class="translation-entry__active-editor-preview"
          [class.outdated]="row().translatedEntry.outdatedInd"
          tabindex="0"
          [attr.data-testid]="'translation-entry-' + row().key + '-editor-preview'"
          (click)="isEditing$.set(true)"
          (focus)="isEditing$.set(true)"
        >
          <div class="ck ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline">
            @if (row().translatedEntry.value) {
              <p [innerHTML]="row().translatedEntry.value"></p>
            } @else {
              <p class="placeholder">Translate to {{ row().languageName }}</p>
            }
          </div>
        </div>
      } @else {
        <eiq-text-editor
          [id]="editorId$()"
          [control]="translatedValueCtrl"
          [autofocus]="true"
          [allowLineBreaks]="true"
          [testId]="'translation-entry-' + row().key"
          (blur)="isEditing$.set(false)"
        ></eiq-text-editor>
      }
    } @else if (!defaultHasValue$()) {
      <span class="fs__sm">No translation source</span>
    } @else {
      <span class="fs__sm">Translation ignored</span>
    }
  </div>
</div>
